import ApolloClientService from './apolloclient.service'
import { constants } from '../constants'

const service = new ApolloClientService()

export default class Settings {
  getClinicSetting = (params) => {
    return new Promise((resolve, reject) => {
      service
        .getClinicSetting(params)
        .then((data) => {
          if (data && data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            reject({ ...(data || {}), error: true })
          }
        })
        .catch((err) => {
          console.log(err)
          reject({ error: true })
        })
    })
  }

  getResolvedClinicSetting = (params) => {
    return new Promise((resolve, reject) => {
      service
        .getResolvedClinicSetting(params)
        .then((data) => {
          if (data && data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            reject({ ...(data || {}), error: true })
          }
        })
        .catch((err) => {
          console.log(err)
          reject({ error: true })
        })
    })
  }

  updateClinicSetting = (params) => {
    return new Promise((resolve, reject) => {
      service
        .updateClinicSetting(params)
        .then((data) => {
          if (data && data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            reject({ ...(data || {}), error: true })
          }
        })
        .catch((err) => {
          console.log(err)
          reject({ error: true })
        })
    })
  }

  // Company level — same contract, keyed by companyid.
  getCompanySetting = (params) => {
    return new Promise((resolve, reject) => {
      service
        .getCompanySetting(params)
        .then((data) => {
          if (data && data.status == constants.MESSAGE.SUCCESS) resolve(data)
          else reject({ ...(data || {}), error: true })
        })
        .catch((err) => {
          console.log(err)
          reject({ error: true })
        })
    })
  }

  updateCompanySetting = (params) => {
    return new Promise((resolve, reject) => {
      service
        .updateCompanySetting(params)
        .then((data) => {
          if (data && data.status == constants.MESSAGE.SUCCESS) resolve(data)
          else reject({ ...(data || {}), error: true })
        })
        .catch((err) => {
          console.log(err)
          reject({ error: true })
        })
    })
  }

  resetCompanySetting = (params) => {
    return new Promise((resolve, reject) => {
      service
        .resetCompanySetting(params)
        .then((data) => {
          if (data && data.status == constants.MESSAGE.SUCCESS) resolve(data)
          else reject({ ...(data || {}), error: true })
        })
        .catch((err) => {
          console.log(err)
          reject({ error: true })
        })
    })
  }

  resetClinicSetting = (params) => {
    return new Promise((resolve, reject) => {
      service
        .resetClinicSetting(params)
        .then((data) => {
          if (data && data.status == constants.MESSAGE.SUCCESS) {
            resolve(data)
          } else {
            reject({ ...(data || {}), error: true })
          }
        })
        .catch((err) => {
          console.log(err)
          reject({ error: true })
        })
    })
  }
}
